import { css } from '@emotion/css'
import { getSkeletonColors } from '../../themes'

const styles = {
  avatar: css({
    margin: 0,
  }),

  rounded: css({
    borderRadius: '50%',
  }),
}

export default styles

export const avatarTheme = theme =>
  css({
    backgroundColor: getSkeletonColors(theme),
  })

export const avatarSize = size => {
  switch (size) {
    case 'small':
      return css({
        flex: '0 0 30px',
        width: 30,
        height: 30,
      })

    case 'medium':
      return css({
        flex: '0 0 60px',
        width: 60,
        height: 60,
      })

    case 'large':
      return css({
        flex: '0 0 90px',
        width: 90,
        height: 90,
      })

    case 'extraLarge':
      return css({
        flex: '0 0 125px',
        width: 125,
        height: 125,
      })

    case 'extraExtraLarge':
      return css({
        flex: '0 0 150px',
        width: 150,
        height: 150,
      })

    default:
      return css({
        flex: '0 0 45px',
        width: 45,
        height: 45,
      })
  }
}
